import { css } from "styled-components";

const gradientBorder = css`
  position: relative;
  overflow: hidden;
  background: white;
  color: black;
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    padding: 2px;
    border-radius: 50px;
    background: linear-gradient(
      90deg,
      #7B3EF0,
      #C85AD0,
      #F9840A,
      #7B3EF0
    );
    background-size: 300%;
    animation: flow 6s ease-in-out infinite;

    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
            mask-composite: exclude;
    z-index: -1;
  }

  &:hover,
  &:focus {
    background: black;
    color: white;
  }

  @keyframes flow {
    0%   { background-position: 0% 50%; }
    50%  { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
`;

export default gradientBorder;
